// 监听整个文档的点击事件
document.addEventListener('click',  function(e) {
  const targetBtn = e.target.closest('.__button_ghost'); 
  if (targetBtn && targetBtn.textContent.trim().toLowerCase()  === 'continue shopping') {
    console.log(' 按钮点击捕获成功');
    e.preventDefault(); 
    setTimeout(() => {
      window.location.reload(true); 
      console.log(' 页面强制刷新执行');
    }, 300);
  }
});